// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },
 //apiUrl: 'https://api.suivievaluation.iwajutech.com/public/api/',

 //apiUrl: 'http://localhost:8000/api/',
 apiUrl: 'https://apiccxproject.iwajutech.com/api/',
    GOOGLE_MAPS_API_KEY: "AIzaSyBnrpKEpOxcM_qBZytRC5FCEdew4OFcaD4",


};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
